'use client';
import classNames from 'classnames';
import React, { useState } from 'react';
import { getIconBaseUrl } from '../../../utils/assets';
import { wrapField } from '../../hooks/useForm';
import ErrorLabel from '../ErrorLabel';
import TopLabel, { InputVariantEnum } from '../TopLabel';
import styles from './textInput.module.scss';
const modeTypeInput = (type) => {
    switch (type) {
        case 'search':
            return { type: 'search', inputMode: 'search' };
        case 'email':
            return { type: 'email', inputMode: 'email' };
        case 'number':
            return { type: 'number', inputMode: 'numeric' };
        case 'password':
            return { type: 'password', inputMode: 'text' };
        case 'text':
            return { type: 'text', inputMode: 'text' };
        case 'tel':
            return { type: 'tel', inputMode: 'tel' };
        default:
            return { type: 'text', inputMode: 'text' };
    }
};
const TextInput = React.forwardRef(({ id, name, label, placeholder, className, value, onChange, onBlur, error, type, disabled, showPassword, setShowPassword, autoComplete, onFocus, onReset, maxLength, reverse, uppercase, iconColor, icon, helperText, narrow, showTopLabel = true, enterKeyHint = 'enter', onKeyDown, variant = InputVariantEnum.DEFAULT, }, ref) => {
    const [focused, setFocused] = useState(false);
    const hasError = !!error;
    const { type: inputType, inputMode } = modeTypeInput(type);
    const handleFocus = () => {
        setFocused(true);
        if (onFocus) {
            onFocus();
        }
    };
    const placeholderText = {
        [InputVariantEnum.DEFAULT]: focused ? undefined : label,
        [InputVariantEnum.LABEL_OUTSIDE]: placeholder,
    };
    return (<>
        <label htmlFor={'textInput' + id} className={classNames(styles.textInput, hasError && styles.error, className, reverse && styles.reverse, uppercase && styles.upperCase, narrow && styles.narrow)}>
          {showTopLabel && variant === InputVariantEnum.LABEL_OUTSIDE && (<>
              <TopLabel className={styles.label} label={label} focused={focused} hasValue={!!value} disabled={disabled} variant={InputVariantEnum.LABEL_OUTSIDE}/>
              {!hasError && helperText && (<span className={classNames(styles.helperText, styles.labelOutside)}>
                  {helperText}
                </span>)}
            </>)}
          <span className={styles.inputInner}>
            {icon ? (<div className={styles.inputIcon} aria-hidden='true' style={Object.assign(Object.assign({}, (iconColor ? { backgroundColor: iconColor } : {})), { WebkitMaskImage: `url(${icon})`, maskImage: `url(${icon})` })}/>) : null}
            <input autoComplete={autoComplete || 'off'} id={'textInput' + id} name={name || id} type={inputType} inputMode={inputMode} placeholder={placeholderText[variant]} value={value} onChange={(event) => {
            onChange(event.target.value);
        }} onBlur={onBlur} disabled={disabled} onFocus={handleFocus} ref={ref} className={classNames({
            [styles.unactive]: !focused,
            [styles.iconPadding]: icon,
        })} maxLength={maxLength} enterKeyHint={enterKeyHint} onKeyDown={onKeyDown}/>
            {setShowPassword && value && (<div className={styles.showPasswordContainer}>
                <button type='button' className={styles.showPassword} onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>)}
            {onReset && value && (<div className={styles.resetInputContainer}>
                <button type='reset' onClick={onReset} className={classNames(styles.resetInput, 'invisible')}>
                  Clear
                </button>
              </div>)}
            {showTopLabel && variant === InputVariantEnum.DEFAULT && (<TopLabel className={styles.label} label={label} focused={focused} hasValue={!!value} disabled={disabled}/>)}
            {hasError && <ErrorLabel error={error}/>}
            {!hasError && variant === InputVariantEnum.DEFAULT && helperText && (<span className={styles.helperText}>
                <img src={getIconBaseUrl('inform-alert.svg')} alt='alert icon'/>
                {helperText}
              </span>)}
          </span>
        </label>
      </>);
});
TextInput.displayName = 'TextInput';
export const TextInputField = wrapField(TextInput);
export default TextInput;
